import { LaunchIcon } from '../icons';

export type IapdLinkButtonProps = {
  crd: string;
  onClick: () => void;
};

export function IapdLinkButton({ crd, onClick }: IapdLinkButtonProps) {
  return (
    <a
      href={`https://adviserinfo.sec.gov/firm/summary/${crd}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-advisor-card-control border border-border bg-card px-2 py-1 text-[0.8125rem] font-semibold text-foreground no-underline hover:border-[var(--content-neutral-light)]"
    >
      View on SEC IAPD
      <LaunchIcon className="size-3.5" />
    </a>
  );
}
